<template>
  <div v-if="items" class="attribute-dropdown">
    <div class="buying-zone__form-label-group">
      <div class="variantName">
        <span class="text-md--semibold" v-html="label" />
      </div>
      <pdp-stock-status
        v-if="renderStockStatus && currentItem && (!children || !children.length)"
        :stock-message="stockMessage"
      />
    </div>
    <div class="select">
      <form-group v-model="selectedOption" type="select" :name="attribute[0].code" :multi-items="items"> </form-group>
    </div>
    <div v-if="currentItem && children && children.length > 0">
      <component
        :is="getAttributeComponent(children)"
        :product="product"
        :base-properties="baseProperties"
        :init-attribute-selection="initAttributeSelection"
        :label="getAttributeLabel(children)"
        :render-stock-status="renderStockStatus"
        :stock-message="stockMessage"
        :is-loading-stock-data="isLoadingStockData"
        :attribute="children"
        @color-changed="
          (color) => {
            $emit('color-changed', color);
          }
        "
        @product-selected="productSelected"
      >
      </component>
    </div>
    <div
      v-if="stockMessage && stockMessage.explanation"
      class="text-gray-60 mb-4"
      v-html="stockMessage.explanation"
    ></div>
  </div>
</template>
<script>
import {Attribute} from '@/components/containers/pdp/attributes/mixins/attribute';
import {AttributeRenderer} from '@/components/containers/pdp/attributes/mixins/attribute-renderer';
import get from 'lodash/get';
import FormGroup from '@/components/FormGroup';
import PdpStockStatus from '@/components/containers/pdp/PdpStockStatus';
import {mapMutations} from 'vuex';

export default {
  name: 'AttributeDropdown',
  components: {FormGroup, PdpStockStatus},
  mixins: [Attribute, AttributeRenderer],
  data() {
    return {
      selectedOption: '',
    };
  },
  computed: {
    items() {
      let items = [
        {
          value: '',
          disabled: true,
          id: '',
          displayName: this.bp('selectVariant'),
        },
      ];

      const metaItemCodes = this.getAttributeMetadataCodes();
      this.attribute.forEach((item) => {
        if (metaItemCodes.includes(item.code)) {
          items.push({
            value: item.options.displayName,
            id: item.options.displayName,
            displayName: item.options.displayName,
          });
        }
      });

      return items;
    },

    children() {
      return get(this.currentItem, 'children', []);
    },

    currentItem() {
      return this.getItem(this.selectedOption);
    },
  },
  watch: {
    items(items) {
      if (this.currentItem) {
        this.$nextTick(this.fireSelectedProduct);
      } else if (items.length - 1 === 1) {
        // Selecting the first value option. Array of items will always have length of 2 or more,
        // where the first item in the list is an empty item (for "Select One" option).
        this.selectedOption = items[1].value;
      }
    },
    selectedOption() {
      this.fireSelectedProduct();
    },
  },
  created() {
    this.initSelectedAttribute();
  },
  mounted() {
    this.productSelected();
  },
  methods: {
    ...mapMutations('savedLists', ['setBuyingZoneEntries']),
    getItem(name) {
      return this.attribute.find((item) => item.options.displayName === name);
    },

    initSelectedAttribute() {
      const initValue = get(this.initAttributeSelection, this.attribute[0].code);
      if (!initValue) {
        if (this.items.length - 1 === 1) {
          this.selectedOption = this.items[1].value;
        }
      } else {
        this.selectedOption = initValue;
      }
    },

    fireSelectedProduct() {
      const productCode = get(this.currentItem, 'options');
      if (productCode) {
        this.productSelected(productCode);
        this.setBuyingZoneEntries([{sku: productCode.productCode, qty: 1}]);
      }
    },
  },
};
</script>
